import {MAX_APPAREILS, MIN_APPAREILS} from "@mytour/shared";
import {Button} from "reactstrap";

type Props = {
  count: number;
  onSelect: (count: number) => void;
  disabled: boolean;
  prefillCount?: number;
};

const COUNT_OPTIONS = Array.from(
  {length: MAX_APPAREILS - MIN_APPAREILS + 1},
  (_, i) => MIN_APPAREILS + i
);

export function ApplianceCountStep({count, onSelect, disabled, prefillCount}: Props) {
  return (
    <>
      <h5 style={{marginBottom: "16px"}}>Nombre d&apos;appareils</h5>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: `repeat(${COUNT_OPTIONS.length}, 1fr)`,
          gap: "8px",
          marginBottom: "12px",
        }}
      >
        {COUNT_OPTIONS.map((n) => (
          <Button
            key={n}
            type="button"
            color={n === count ? "primary" : "outline-secondary"}
            disabled={disabled}
            onClick={() => onSelect(n)}
          >
            {n}
          </Button>
        ))}
      </div>
      {prefillCount !== undefined && (
        <p style={{fontSize: "13px", color: "#666"}}>
          Repris de la dernière attestation de ce client :{" "}
          <strong>
            {prefillCount} appareil
            {prefillCount > 1 ? "s" : ""}
          </strong>
          . Chaque appareil aura ses propres écrans, la signature vient à la fin.
        </p>
      )}
    </>
  );
}
